<template>
    <div class="section-row">
        <span class="section-row-header">{{ heading }}</span>

        <form
            class="vue-form"
            :method="'POST'"
            novalidate="novalidate"
            @submit.prevent="submitPostalCode">
            <div class="vue-form">
                <div class="vue-form-row has-multiple-elements">
                    <vue-input :element="fieldData"
                        @input="setPostalCode($event.target.value)" />
                    <vue-input :element="buttonData" />
                </div>
            </div>
        </form>
    </div>
</template>
<script src="./postal-code-form.js"/>
